import axios from 'axios'
import { IUnit } from './Units'

const server = process.env.REACT_APP_SERVER_URL

export const createComposition = async (
  composition: any
): Promise<IComposition> => {
  try {
    const response = await axios.post<ICreateCompositionResponseDTO>(
      `${server}/inventory/composition`, composition)
    return response.data.newComposition
  } catch (error) {
    throw error
  }
}

export const removeComposition = async (
  id: string
): Promise<ICompositionDTO> => {
  try {
    const response = await axios.delete<IDeleteCompositionDTO>(
      `${server}/inventory/composition?id=${id}`
    )
    return response.data.deletedCompoundItem
  } catch (error) {
    throw error
  }
}

export const updateComposition = async (
  idAndAmount: IUpdateCompositionDTO
): Promise<ICompositionDTO> => {
  try {
    const response = await axios.patch<IUpdateCompositionResponseDTO>(
      `${server}/inventory/composition`,
      {
        composition: idAndAmount,
      }
    )
    return response.data.updatedComposition
  } catch (error) {
    throw error
  }
}

interface ICreateCompositionResponseDTO {
  status: number
  message: string
  newComposition: IComposition
}

interface IDeleteCompositionDTO {
  status: number
  message: string
  deletedCompoundItem: ICompositionDTO
}

interface IUpdateCompositionDTO {
  id: string
  amount: string
}

interface IUpdateCompositionResponseDTO {
  status: number
  message: string
  updatedComposition: ICompositionDTO
}

interface ICompositionDTO {
  amount: string
  compound_item: {
    id: string
  }
  id: string
  item: {
    id: string
  }
}

export interface ICreateCompositionDTO {
  amount: string
  compound_item: string
  item: {
    id: string
  }
}

export interface IComposition {
  id: string
  item: {
    name: string
    id: string
    unit: IUnit
    price: string
    cost: string
    exempt: boolean
  }
  amount: number
}
